import api from "./axios";

export const getConversations = (params = {}) =>
  api.get("/conversations", { params });

export const getConversation = (conversationPublicId) =>
  api.get(`/conversations/${conversationPublicId}`);

export const getConversationMessages = (
  conversationPublicId,
  params = {},
) => api.get(`/conversations/${conversationPublicId}/messages`, { params });

export const markConversationRead = (conversationPublicId) =>
  api.post(`/conversations/${conversationPublicId}/read`);

export const updateConversation = (conversationPublicId, data) =>
  api.patch(`/conversations/${conversationPublicId}`, data);

export const takeConversation = (conversationPublicId) =>
  api.post(`/conversations/${conversationPublicId}/take`);

export const returnConversationToAI = (conversationPublicId) =>
  api.post(`/conversations/${conversationPublicId}/return-to-ai`);

export const returnAllConversationsToAI = () =>
  api.post("/conversations/return-all-to-ai");

export const assignConversation = (conversationPublicId, userPublicId) =>
  api.post(`/conversations/${conversationPublicId}/assign`, {
    user_public_id: userPublicId,
  });

export const unassignConversation = (conversationPublicId) =>
  api.post(`/conversations/${conversationPublicId}/unassign`);

export const sendConversationReply = (conversationPublicId, text, idempotencyKey) =>
  api.post(
    `/conversations/${conversationPublicId}/messages`,
    { text },
    { headers: { "Idempotency-Key": idempotencyKey } },
  );
